export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-300">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-[1200px] mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 mb-10 md:mb-14">
            <div className="col-span-2 md:col-span-1">
              <a href="#hero" className="flex items-center gap-2 mb-4">
                <span className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center flex-shrink-0">
                  <i className="ri-play-fill text-background-50 text-base"></i>
                </span>
                <span className="font-heading text-lg font-bold text-background-50">桃花视频</span>
              </a>
              <p className="text-sm text-background-400 leading-relaxed max-w-[260px]">
                聚合红桃视频、樱桃视频、茄子视频、糖心视频等主流平台，高清免费在线观看，每日更新，流畅不卡顿。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-100 mb-4">快速导航</h4>
              <div className="flex flex-col gap-2.5">
                <a href="#cards" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap">精选推荐</a>
                <a href="#ranking" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap">热播榜单</a>
                <a href="#topics" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap">热门话题</a>
                <a href="#updates" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap">最新动态</a>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-100 mb-4">平台资源</h4>
              <div className="flex flex-col gap-2.5">
                <a href="#media" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap">精彩视频</a>
                <a href="#carousel" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap">焦点推荐</a>
                <a href="#faq" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap">常见问题</a>
                <a href="#about" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap">关于我们</a>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-100 mb-4">合作伙伴</h4>
              <p className="text-sm text-background-500 leading-relaxed">
                更多优质合作伙伴正在入驻中
              </p>
            </div>
          </div>

          <div className="border-t border-background-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} 桃花视频 - 聚合全网优质影视资源，高清免费在线观看
            </p>
            <div className="flex items-center gap-4">
              <a href="#hero" className="text-xs text-background-500 hover:text-background-300 transition-colors">回到顶部</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}